import { CUBE } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyProperties } from './base';

export class Cube extends BaseObject {
  constructor() {
    super(
      new THREE.BoxGeometry(CUBE.WIDTH, CUBE.HEIGHT, CUBE.DEPTH),
      new THREE.MeshStandardMaterial({ color: CUBE.COLOR })
    );

    this.width = CUBE.WIDTH;
    this.depth = CUBE.DEPTH;
    this.height = CUBE.HEIGHT;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.BoxGeometry(this.width, this.height, this.depth);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      let needsUpdate = false;

      if ('width' in properties && properties.width !== this.width) {
        this.userData.data.width = properties.width;
        this.width = properties.width;
        needsUpdate = true;
      }
      if ('depth' in properties && properties.depth !== this.depth) {
        this.userData.data.depth = properties.depth;
        this.depth = properties.depth;
        needsUpdate = true;
      }
      if ('height' in properties && properties.height !== this.height) {
        this.userData.data.height = properties.height;
        this.height = properties.height;
        needsUpdate = true;
      }

      if (needsUpdate) this.updateGeometry();
    };
  }
}
